export var MessagesList = {
  2: { parts_length:0 },
  59: ["string"],
  60: {
    parts_length: 1,
    data: [{ name: "settings", type: "string" }],
  },
  61: ["string"],
  63: {
    parts_length: 12,
    data: [
      { name: "serverSeedSHA256", type: "string" },
      { name: "clientSeed", type: "string" },
      { name: "nonce", type: "int" },
      { name: "balance", type: "number" },
      { name: "user_id", type: "string" },
      { name: "user_name", type: "base64" },
      { name: "maxwin", type: "number" },
      { name: "minBet", type: "number" },
      { name: "maxBet", type: "number" },
      { name: "currency", type: "string" },
      { name: "precision", type: "int" },
      { name: "next_server_seed_SHA256", type: "string" },
    ],
  },
  67: {
    parts_length: 13,
    data: [
      { name: "round_id", type: "string" },
      { name: "user_name", type: "base64" },
      { name: "user_id", type: "string" },
      { name: "betAmount", type: "number" },
      { name: "winAmount", type: "number" },
      { name: "winCoef", type: "number" },
      { name: "currency", type: "string" },
      { name: "bigWin", type: "int" },
      { name: "bet_id", type: "int" },
      { name: "history", type: "int" },
      { name: "time", type: "string" },
      { name: "gameplay", type: "string" },
      { name: "sessionNo", type: "string" },
    ],
  },
  90: {
    parts_length: 1,
    data: [{ name: "errorCode", type: "int" }],
  },
  101: ["string"],
  116: ["string"],
  117: {
    parts_length: 15,
    data: [
      { name: "user_id", type: "string" },
      { name: "user_name", type: "base64" },
      { name: "bet_id", type: "int" },
      { name: "round_id", type: "string" },
      { name: "betAmount", type: "number" },
      { name: "winAmount", type: "number" },
      { name: "currency", type: "string" },
      { name: "winCoef", type: "number" },
      { name: "bigWin", type: "int" },
      { name: "server_seed", type: "string" },
      { name: "server_seed_SHA256", type: "string" },
      { name: "client_seed", type: "string" },
      { name: "nonce", type: "int" },
      { name: "date", type: "string" },
      {
        name: "userActions",
        type: "arrayobjects",
        delimeter: ";",
        parts_length: 2,
        obj: {
          delimeter: ":",
          data: [
            { name: "card", type: "int" },
            { name: "cardName", type: "string" },
            { name: "action", type: "string" },
            { name: "coef", type: "number" },
          ],
        },
      },
    ],
  },
  118: {
    parts_length: 7,
    data: [
      { name: "server_seed_SHA256", type: "string" },
      { name: "client_seed", type: "string" },
      { name: "nonce", type: "int" },

      { name: "old_server_seed", type: "string" },
      { name: "old_server_seed_SHA256", type: "string" },
      { name: "old_client_seed", type: "string" },
      { name: "old_nonce", type: "int" },
    ],
  },
  119: {
    parts_length: 8,
    data: [
      { name: "server_seed_SHA256", type: "string" },
      { name: "client_seed", type: "string" },
      { name: "nonce", type: "int" },
      { name: "old_server_seed", type: "string" },
      { name: "old_server_seed_SHA256", type: "string" },
      { name: "old_client_seed", type: "string" },
      { name: "old_nonce", type: "int" },
      { name: "next_server_seed_SHA256", type: "string" },
    ],
  },
  124: ["number"],
  125: ["string"],
  126: {},
  127: {
    parts_length: 10,
    data: [
      { name: "currentBetId", type: "string" },
      { name: "balance", type: "number" },
      { name: "bet", type: "number" },
      { name: "currentCoef", type: "number" },
      { name: "hiCoef", type: "number" },
      { name: "loCoef", type: "number" },
      { name: "state", type: "int" },
      {
        name: "userActions",
        type: "arrayobjects",
        delimeter: ";",
        parts_length: 2,
        obj: {
          delimeter: ":",
          data: [
            { name: "card", type: "int" },
            { name: "cardName", type: "string" },
            { name: "action", type: "string" },
            { name: "coef", type: "number" },
          ],
        },
      },
      { name: "currentCard", type: "int" },
      { name: "won", type: "number" },
    ],
  },
};
